// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 3 hooks for backend/payments.

import { useBackend } from '../useBackend'

/** POST /api/payments/getPaymentFileUrl */
export function useGetPaymentFileUrl<T = any>() {
  return useBackend<T>('payments/getPaymentFileUrl')
}

/** POST /api/payments/recordPaymentFile */
export function useRecordPaymentFile<T = any>() {
  return useBackend<T>('payments/recordPaymentFile')
}

/** POST /api/payments/signPaymentFileUpload */
export function useSignPaymentFileUpload<T = any>() {
  return useBackend<T>('payments/signPaymentFileUpload')
}
